import { render, staticRenderFns } from "./Notificador.vue?vue&type=template&id=47662034&"
import script from "./Notificador.vue?vue&type=script&lang=js&"
export * from "./Notificador.vue?vue&type=script&lang=js&"
import style0 from "./Notificador.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports